import React from 'react';
import { Typography, Box } from '@mui/material';
import Sidebar from '../components/Sidebar';

const SuperadminDashboard: React.FC = () => {
  return (
    <Box sx={{ display: 'flex' }}>
      <Sidebar role="superadmin" />
      <Box sx={{ flexGrow: 1, p: 3, mt: 8 }}>
        <Typography variant="h4" gutterBottom>
          Superadmin Dashboard
        </Typography>
        <Typography>Welcome to the superadmin panel.</Typography>
      </Box>
    </Box>
  );
};

export default SuperadminDashboard;